import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, onProductClick }) => {
  const [itemsPerPage, setItemsPerPage] = useState(8);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 640) {
        setItemsPerPage(12); // mobile: 2 x 4
      } else if (width < 1024) {
        setItemsPerPage(6); // tablet
      } else {
        setItemsPerPage(9); // desktop
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const visibleProducts = products.slice(0, itemsPerPage);

  if (products.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-[400px] bg-white rounded-[39px] shadow-lg">
        <p className="text-gray-500 text-lg">No Products Found</p>
      </div>
    );
  }

  return (
  <div className="
  grid grid-cols-2 sm:grid-cols-2 xl:grid-cols-3
  gap-4 p-4 bg-white shadow-lg rounded-[39px] w-full
  items-stretch
">
 {visibleProducts.map((product, index) => (
        <motion.div
          key={product.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.05 }}
          className="flex"
        >
          <ProductCard
            id={product.id}
            image={product.image}
            title={product.name}
            onProductClick={onProductClick}
          />
        </motion.div>
      ))}
    </div>
  );
};

export default ProductGrid;